// Parties d'un constat (miroir de backend/parties.py)
export function locataires(etat, side) {
  const out = [{ key: `locataire_${side}`, label: `Locataire ${side}`, nom: etat[`locataire_${side}`] || "", email: etat[`email_locataire_${side}`] || "" }];
  (etat[`colocataires_${side}s`] || []).forEach((c, i) => {
    if ((c.nom || "").trim()) out.push({ key: `locataire_${side}_${i + 2}`, label: `Locataire ${side} ${i + 2}`, nom: c.nom, email: c.email || "" });
  });
  return out;
}

export function sigRoles(etat) {
  const roles = [{ key: "bailleur", label: "Pour le bailleur / la gérance", nom: etat.gerant_responsable || "" }];
  if (etat.type_constat !== "sortie") roles.push(...locataires(etat, "entrant"));
  if (etat.type_constat !== "entree") roles.push(...locataires(etat, "sortant"));
  return roles;
}

export function destinataires(etat) {
  const out = [];
  if (etat.type_constat !== "sortie") out.push(...locataires(etat, "entrant"));
  if (etat.type_constat !== "entree") out.push(...locataires(etat, "sortant"));
  out.push({ key: "proprietaire", label: "Propriétaire / bailleur", nom: etat.proprietaire || "", email: etat.email_proprietaire || "" });
  return out;
}
